export default "__VITE_ASSET__e5I4jXox__"